var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrivers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 4.625C22.25 4.19402 22.0788 3.7807 21.774 3.47595C21.4693 3.1712 21.056 3 20.625 3C20.194 3 19.7807 3.1712 19.476 3.47595C19.1712 3.7807 19 4.19402 19 4.625V9.5H22.25V4.625ZM24.6875 11.125H6.8125C6.59701 11.125 6.39035 11.2106 6.23798 11.363C6.0856 11.5153 6 11.722 6 11.9375V13.5625C6 13.778 6.0856 13.9847 6.23798 14.137C6.39035 14.2894 6.59701 14.375 6.8125 14.375H7.625V16C7.62529 17.8729 8.27231 19.6882 9.45668 21.1391C10.641 22.5899 12.2901 23.5873 14.125 23.9625V29H17.375V23.9625C19.2099 23.5873 20.859 22.5899 22.0433 21.1391C23.2277 19.6882 23.8747 17.8729 23.875 16V14.375H24.6875C24.903 14.375 25.1097 14.2894 25.262 14.137C25.4144 13.9847 25.5 13.778 25.5 13.5625V11.9375C25.5 11.722 25.4144 11.5153 25.262 11.363C25.1097 11.2106 24.903 11.125 24.6875 11.125ZM12.5 4.625C12.5 4.19402 12.3288 3.7807 12.024 3.47595C11.7193 3.1712 11.306 3 10.875 3C10.444 3 10.0307 3.1712 9.72595 3.47595C9.4212 3.7807 9.25 4.19402 9.25 4.625V9.5H12.5V4.625Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 26,
    fill: "currentColor",
    transform: "translate(6 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivers);
export default __webpack_public_path__ + "static/media/drivers.6f5bdc325667c61a48a803ab21a93580.svg";
export { ForwardRef as ReactComponent };